import { render, staticRenderFns } from "./NftBox.vue?vue&type=template&id=1796e740&"
import script from "./NftBox.vue?vue&type=script&lang=js&"
export * from "./NftBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports